import { Div, Flex, Text } from '@sendoutcards/quantum-design-ui'
import React from 'react'

import { Button } from 'src/design_system/components/Button/Button'
import { useAccount, useContainerWidth } from 'src/hooks'

type GratitudeMovementWidgetType = {
  title: string
  isMobile?: boolean
  isTablet?: boolean
}

export const GratitudeMovementWidget: React.FC<GratitudeMovementWidgetType> = ({
  title,
  isMobile,
  isTablet,
}) => {
  const [containerRef] = useContainerWidth()

  const account = useAccount()

  return (
    <Flex
      width="100%"
      flexDirection="column"
      backgroundColor="#fff"
      alignItems="center"
      borderRadius="32px"
      minWidth="340px"
      height="inherit"
      inset={{ top: 'x1', right: 'x2', bottom: 'x2', left: 'x2' }}
      style={{ boxShadow: 'rgba(0, 0, 0, 0.04) 0px 4px 32px' }}
    >
      <Div
        ref={containerRef}
        display="flex"
        width="100%"
        flexDirection="column"
        justifyContent="center"
        alignItems="flex-start"
        height="50px"
      >
        <Text
          inset="8px"
          type="caption"
          content={title}
          style={{ fontSize: '16px', fontWeight: 600, color: '#404040' }}
          alignment="left"
        />
      </Div>
      <Flex
        width="100%"
        justifyContent="center"
        alignItems="center"
        height="100%"
        outset={{ top: 'x3', bottom: 'x2' }}
      >
        <Flex
          inset={{ horizontal: '44px' }}
          style={{
            backgroundRepeat: 'no-repeat',
            backgroundColor: '#FEFEFE',
            width: '80%',
            backgroundSize: 'contain',
            backgroundPosition: 'center',
            height: '100%',
            minHeight: '200px',
            backgroundImage:
              'url(https://soc-website-public.s3.us-west-2.amazonaws.com/static/soc-website/images/manual/GratitudeWebGraphic.png)',
            position: 'relative',
            borderRadius: 20,
          }}
          cursor="pointer"
          onClick={() =>
            window.open(
              `https://promptings.com/presentation?sponsor=${account.genealogyId}`,
              '_blank',
            )
          }
        />
      </Flex>
      <Flex
        width="100%"
        inset={{ vertical: 'x1' }}
        justifyContent="center"
        alignItems="center"
      >
        <Button
          title={'Go To Presentation'}
          background="#424448"
          textColor="#FFF"
          textSize={'14px'}
          whiteSpace="nowrap"
          width="80%"
          onClick={() =>
            window.open(
              `https://promptings.com/presentation?sponsor=${account.genealogyId}`,
              '_blank',
            )
          }
        />
      </Flex>
    </Flex>
  )
}
